import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import ProductDetail from "../pages/product-detail/page";
import Cart from "../pages/cart/page";
import Checkout from "../pages/checkout/page";
import Reviews from "../pages/reviews/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/products", element: <Products /> },
  { path: "/product/:id", element: <ProductDetail /> },
  { path: "/cart", element: <Cart /> },
  { path: "/checkout", element: <Checkout /> },
  { path: "/reviews", element: <Reviews /> },
  { path: "/about", element: <About /> },
  { path: "/about/quality", element: <About /> },
  { path: "/about/contact", element: <About /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
